module.exports = __webpack_public_path__ + "img/logos_twitter.911e3d83.svg";